import { t } from "@travily/i18n";
import { ButtonDock } from "@ui/components/ButtonDock";
import { Dialog } from "@ui/components/Dialog";
import { Icon } from "@ui/components/Icon";
import { StandardButton } from "@ui/components/StandardButton";
import { StandardTextArea } from "@ui/components/StandardTextArea";

export interface CelebrationModalProps {
  close: () => void;
  body: string;
  onBodyChange: (value: string) => void;
  onSubmit: () => void;
  isPending: boolean;
  bodyError?: string;
}

export function CelebrationModal({ close, body, onBodyChange, onSubmit, isPending, bodyError }: CelebrationModalProps) {
  return (
    <>
      <Dialog.Header onClose={close} title={t("components.views.accounts.celebration_modal.title")} />
      <Dialog.Body>
        <div className="px-1">
          <StandardTextArea
            errorMessage={bodyError}
            isInvalid={!!bodyError}
            isLabelHidden
            label={t("components.views.accounts.celebration_modal.label")}
            leadIcon={<Icon name="message" type="sticker" />}
            onChange={onBodyChange}
            placeholder={t("components.views.accounts.celebration_modal.placeholder")}
            value={body}
          />
        </div>
      </Dialog.Body>
      <Dialog.Footer>
        <ButtonDock
          primaryAction={
            <StandardButton color="pink" isPending={isPending} onPress={onSubmit} size="44">
              {t("common.actions.post")}
            </StandardButton>
          }
        />
      </Dialog.Footer>
    </>
  );
}
